module.exports = __webpack_public_path__ + "static/media/resume_Lertkantitham.cee1c604.pdf";